import script from "./Whiteboard.vue?vue&type=script&setup=true&lang=js"
export * from "./Whiteboard.vue?vue&type=script&setup=true&lang=js"

import "./Whiteboard.vue?vue&type=style&index=0&id=2fdbd589&lang=css"

const __exports__ = script;

export default __exports__